import { render, staticRenderFns } from "./AlertsIncidentsTable.vue?vue&type=template&id=59fb6baa&"
import script from "./AlertsIncidentsTable.vue?vue&type=script&lang=js&"
export * from "./AlertsIncidentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports